import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';
import { format } from "date-fns";

class CustomOption extends React.Component{
    constructor(){
        super();
        this.state={
            opacity : "",
        };
    }
    componentWillMount(){
        const layer = this.props.layer;
        var CustomLayer = this.props.layer.layerHandel;
        this.setState({opacity: 100});
    }
    sidebarChange(event){
        const customLayer = this.props.layer.layerHandel;
        customLayer.entities.forEach(function(entity) {
            entity.update({opacity: event.target.value/100});
        });
        const defaultOpacity = customLayer._layer._Entities[0]._Opacity * 100;
        this.setState({opacity:defaultOpacity});
    }
    deleteLayerList(layer){
        const Layer = {
            GROUP:layer.group,
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        if(this.props.layer.layerLocation!=null){
            var Pos = new window.Geo3DPoint(this.props.layer.layerLocation.POS.x , this.props.layer.layerLocation.POS.y , this.props.layer.layerLocation.POS.z);
            var V = new window.Geo3DPoint(this.props.layer.layerLocation.V.x , this.props.layer.layerLocation.V.y , this.props.layer.layerLocation.V.z);
            var Up = new window.Geo3DPoint(this.props.layer.layerLocation.UP.x , this.props.layer.layerLocation.UP.y , this.props.layer.layerLocation.UP.z);
            var Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
        }
        else{
            var CustomLayer = this.props.layer.layerHandel;
            CustomLayer.goto();
        }
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large building icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}</h6>
                            </div>
                        </div> 
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <label className="ts two wide column right aligned">{(this.state.opacity).toFixed(1)}%</label>
                    <input type="range" min="0" max="100" defaultValue={this.state.opacity} step="1" onChange={(e)=>this.sidebarChange(e)} style={siderRangeCSS}></input>
                </div>
            </div>
        );
    }
}

class CustomLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            customLayer:{},
            geojsonData: {},
            dtData: {},
        };   
        this.customLayerChecked = this.customLayerChecked.bind(this);      
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if (prevState.customLayer !== this.state.customLayer && this.state.isChecked) {
            this.getDtData();
        }
        if (prevProps.layer.TITLE === this.props.layer.TITLE && prevProps.currentTime.length != 0) {
            if (prevState.isChecked && format(prevProps.currentTime[0], 'yyyyMMddHH') !== format(this.props.currentTime[0], 'yyyyMMddHH')) {
                if (this.state.isChecked) {
                    this.drawEntity();
                }
            }
        }
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.customLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,customLayer:{}});
            }            
        }
    }
    getColor(val){
        let legend = this.props.layer.LEGEND;
        for (var i = 0; i < legend["VALUE"].length; i ++) {
            if (val == null && legend["VALUE"][i] == "無資料") {
                return legend["COLOR"][i];
            } else if (val < legend["VALUE"][i] && i !== 0) {
                return legend["COLOR"][i - 1];
            } else if (legend["VALUE"][i] < val && i+1 == legend["VALUE"].length) {
                return legend["COLOR"][i];
            }
        }
        return legend["COLOR"][0];
    }
    drawEntity(){
        let layer = this.props.layer;
        let layerHandel = this.state.customLayer;
        let data = this.state.dtData;
        let dt = format(layer.TIMELINE.SELECTEDINTERVAL[0],'yyyyMMddHH');
        if (this.props.currentTime.length != 0)
            dt = format(this.props.currentTime[0],'yyyyMMddHH');
        var opacity = 1;
        if (layerHandel.entities.length > 0) {
            opacity = layerHandel.entities[0]._entity._Opacity;
        }
        layerHandel.removeAllEntity();
        const layerThis = this;        
        switch (layer.GEOMETRY) {
            case "polygon":
                layerThis.state.geojsonData.features.forEach(function (f) {
                    let id = f.properties["grid_ID"];
                    let val = null;
                    if (data[dt] != undefined)
                        val = data[dt][id]
                    let polygon = new window.GeoPolygonSet();
                    polygon.FromGeoJSON(f.geometry);
                    layerHandel.addPolygonPrismEntity({
                        geo: polygon,
                        color: layerThis.getColor(val),
                        opacity: opacity,
                        drawBorder: true,
                        borderColor: "#FFFFFF",
                        epsg: 4326
                    }).setTooltip("grid_ID：" + f.properties["grid_ID"] + "</br>噪音值：" + ((val == null) ? "無資料" : val));
                });
                break;
            case "polyline":
                let type = (layer.ID == "taipei_vd_avgspeed")||(layer.ID == "taichung_road_avgspeed") ? "平均車速" : "總車流量";
                layerThis.state.geojsonData.features.forEach(function (f) {
                    let id = f.properties["VD編號"];
                    let val = null;
                    if (data[dt] != undefined)
                        val = data[dt][id]
                    let polyline = new window.GeoPolyline();
                    polyline.FromGeoJSON(f.geometry);
                    if (polyline.Buffer.length > 1) {
                        layerHandel.addGroundPolylineEntity({
                            geo: polyline,
                            color: layerThis.getColor(val),
                            size: 4,
                            opacity: opacity,
                            epsg: 4326
                        }).setTooltip(f.properties["道路"]+"</br>"+f.properties["大街廓"]+"</br>"+type+"："+ ((val == null) ? "無資料" : val));
                    }
                });
                break;
        }
    }
    divTime(time){
        let time1 = Date.parse(time[0]);
        let time2 = Date.parse(time[1]);
        return Math.abs(parseInt((time2 - time1) / 1000 / 3600));
    }
    getDtData(){
        let layer = this.props.layer;
        let layerHandel = this.state.customLayer;
        let dt_s = format(layer.TIMELINE.TIMElINEINTERVAL[0],'yyyyMMddHH');
        let range = this.divTime(layer.TIMELINE.TIMElINEINTERVAL);
        const d = {
            type: layer.ID,
            dt_s: dt_s,
            range: range
        };
        const formData = Object.keys(d).map(function (keyName) {
            return encodeURIComponent(keyName) + '=' + encodeURIComponent(d[keyName])
        }).join('&');
        if (!this.state.dtData.hasOwnProperty(dt_s)) {
            if (layer.FETCHURL !== undefined) {
                fetch(layer.FETCHURL, {
                        method: "POST",
                        body: formData,
                        headers: new Headers({
                            "Content-type": "application/x-www-form-urlencoded"
                        })
                    })
                    .then(res => res.json())
                    .then(data => {
                        this.setState({dtData: data});
                        this.drawEntity();
                    })
                    .catch(e => {
                        console.log(e);
                        console.log("取得資料失敗");
                    })
            }
        } else {
            this.drawEntity();
        }
    }
    customLayerChecked(layer){
        let isChecked = this.state.isChecked;
        let geojsonData = {};
        const layerThis = this;        
        if(!isChecked){
            window.main.OView.drawTerrainSetting = {noElevation: true};
            window.main.OView.addCustomLayer({
                layername: layer.ID,
                callback: function (success, customLayer) {
                    if (success) {
                        if (!layerThis.state.geojsonData.hasOwnProperty("features")) {
                            fetch(layer.GEOJSONURL, {
                                    method: "GET",
                                    headers: new Headers({
                                        'Content-Type': 'application/json'
                                    })
                                })
                                .then(res => res.json())
                                .then(data => {
                                    layerThis.setState({geojsonData: data});
                                })
                                .catch(e => {
                                    console.log(e);
                                    console.log("無法取得geojson");
                                })
                        }
                        if (layer.LOCATION!=null) {
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x , layer.LOCATION.POS.y , layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x , layer.LOCATION.V.y , layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x , layer.LOCATION.UP.y , layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos,V,Up);
                            window.main.OView.gotoCamera(Camera, true);
                        } else {
                            customLayer.goto();
                        }
                        layerThis.props.setOpenLayer(layer,customLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({ isChecked: isChecked, customLayer: customLayer });
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        if (layer.LEGEND !== undefined)
                            layerThis.props.setLegendBoxContent(layer.LEGEND);
                        if (layer.TIMELINE !== undefined)
                            layerThis.props.setTimeLineContent(layer.TIMELINE);
                    } else {
                        window.alertify.error("連結不到圖層:：" + layer.TITLE);
                    }
                }
            });         
        } else {
            window.main.OView.removeLayer(this.state.customLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;
            layerThis.setState({isChecked:isChecked,customLayer:{}});
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="CustomLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.customLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {CustomLayer, CustomOption};